import React, { memo, useMemo } from "react";

const TableCell = memo(function TableCell({
  rowIndex,
  fieldId,
  isFocused,
  isInSelection,
  copiedEdges,
  selectionEdges,
  isEditing,
  onMouseDown,
  onClick,
  children,
}) {
  const cellStyle = useMemo(() => {
    const style = {
      borderTop: "2px solid transparent",
      borderBottom: "2px solid transparent",
      borderLeft: "2px solid transparent",
      borderRight: "2px solid transparent",
    };

    if (selectionEdges) {
      if (selectionEdges.top) {
        style.borderTop = "2px solid var(--color-accent-primary)";
      }
      if (selectionEdges.bottom) {
        style.borderBottom = "2px solid var(--color-accent-primary)";
      }
      if (selectionEdges.left) {
        style.borderLeft = "2px solid var(--color-accent-primary)";
      }
      if (selectionEdges.right) {
        style.borderRight = "2px solid var(--color-accent-primary)";
      }
    }

    if (copiedEdges) {
      if (copiedEdges.top) {
        style.borderTop = "2px dashed var(--color-accent-primary-dim)";
      }
      if (copiedEdges.bottom) {
        style.borderBottom = "2px dashed var(--color-accent-primary-dim)";
      }
      if (copiedEdges.left) {
        style.borderLeft = "2px dashed var(--color-accent-primary-dim)";
      }
      if (copiedEdges.right) {
        style.borderRight = "2px dashed var(--color-accent-primary-dim)";
      }
    }

    if (isFocused) {
      style.outline = "2px solid var(--color-accent-primary)";
      style.outlineOffset = "-1px";
      style.zIndex = 10;
      style.position = "relative";
    }

    return style;
  }, [copiedEdges, isFocused, selectionEdges]);

  return (
    <td
      data-row={rowIndex}
      data-field={fieldId}
      className={`px-4 py-2 text-[12px] text-text-secondary align-middle font-mono cursor-pointer ${
        isInSelection ? "bg-accent-primary/20" : ""
      } ${isEditing ? "" : "select-none"}`}
      style={cellStyle}
      onMouseDown={onMouseDown}
      onClick={onClick}
    >
      {children}
    </td>
  );
});

export default TableCell;
